import { useEffect, useState } from "react";
import { CreditCard } from "lucide-react";
import { api } from "@/lib/api";
import { useI18n } from "@/i18n/I18nContext";

export const StripeBadge = () => {
  const { t } = useI18n();
  const [s, setS] = useState(null);
  useEffect(() => {
    api.get("/admin/billing/status").then(({ data }) => setS(data)).catch(() => {});
  }, []);
  if (!s) return null;
  const key = !s.available ? "off" : s.live ? "live" : "test";
  const tone = { live: "border-emerald-400/60 bg-emerald-500/10 text-emerald-200", test: "border-amber-300/60 bg-amber-400/10 text-amber-100", off: "border-red-400/60 bg-red-500/10 text-red-200" }[key];
  return (
    <div className={`flex flex-wrap items-center gap-2 rounded-2xl border px-4 py-3 text-sm font-semibold ${tone}`} data-testid="stripe-mode-badge" data-mode={key}>
      <CreditCard className="h-4 w-4 shrink-0" />
      <span className="min-w-0">{t(`stripe.badge.${key}`)}</span>
      {s.live && s.account_info && !s.account_info.charges_enabled && <span className="text-xs font-normal">· {t("stripe.badge.chargesOff")}</span>}
    </div>
  );
};
